import { useMemo, useState } from 'react';
import { addDagen, bezetting, fmtDag, fmtUren, isoWeek, maandagVan, sprintBelasting } from '@ep/core';
import { useData } from '../lib/data';
import { Laden } from '../ui/ui';

const KLEUR = { groen: 'var(--groen-bg)', oranje: 'var(--oranje-bg)', rood: 'var(--rood-bg)', afwezig: 'var(--paars-bg)', voorbij: 'var(--lijn-2)' };

export function Bezetting() {
  const { data: d, kal } = useData();
  const [start, setStart] = useState<string | null>(null);
  // SPEC §4.9: standaard 2 weken terug en 8 weken vooruit
  const TERUG = 2;
  const AANTAL = TERUG + 8;
  const deze = d ? maandagVan(d.vandaag) : '';
  const ma = start ?? (d ? addDagen(deze, -7 * TERUG) : '');
  const rijen = useMemo(() => {
    if (!d || !kal) return [];
    // SPEC §9.7: geschat sprintwerk telt mee in de bezetting
    const sp = sprintBelasting({ kal, sprints: d.sprints ?? [], werkpakketten: d.werkpakketten, items: d.takenpakketten, vandaag: d.vandaag });
    return d.engineers.filter((e) => e.actief !== false && e.inzet !== 'NIET_CAPACITEIT').map((e) => ({ e, cellen: bezetting(kal, e.id, ma, AANTAL, d.vandaag, sp.get(e.id)) }));
  }, [d, kal, ma]);
  if (!d || !kal) return <Laden />;
  const weken = Array.from({ length: AANTAL }, (_, i) => addDagen(ma, i * 7));
  return (
    <div className="pagina">
      <div className="paneel">
        <div className="sectie-kop">
          <h1 className="groei">Bezetting per week</h1>
          <button className="knop" onClick={() => setStart(addDagen(ma, -28))}>◀ 4 weken</button>
          <button className="knop" onClick={() => setStart(null)}>Deze week</button>
          <button className="knop" onClick={() => setStart(addDagen(ma, 28))}>4 weken ▶</button>
        </div>
        <p className="klein mute">Gepland in de app (incl. reistijd), geschat sprintwerk van agile werkpakketten en overige afspraken in Outlook, gedeeld door de beschikbare uren vanaf vandaag. Groen &lt; 80%, oranje 80–100%, rood &gt; 100%. De eerste twee kolommen zijn de afgelopen weken (hele week).</p>
        <div style={{ overflowX: 'auto' }}>
          <table className="tabel">
            <thead>
              <tr>
                <th>Engineer</th>
                {weken.map((w, i) => {
                  const cel = rijen.map((r) => r.cellen[i]);
                  const g = cel.reduce((s, c) => s + c.gepland + c.bezet + c.sprint, 0);
                  const b = cel.reduce((s, c) => s + c.beschikbaar, 0);
                  const terug = w < deze;
                  return (
                    <th key={w} className={w === deze ? 'bez-nu' : terug ? 'bez-terug' : undefined} style={{ textAlign: 'center' }}>
                      Wk {isoWeek(w)} · {fmtDag(w, 'datum')}
                      <div className="klein">{b > 0 ? (terug ? `team ${Math.round((g / b) * 100)}% · geweest` : `team ${Math.round((g / b) * 100)}% · ${fmtUren(Math.max(0, b - g))}u vrij`) : '–'}</div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {rijen.map(({ e, cellen }) => (
                <tr key={e.id}>
                  <td className="vet nowrap">{e.naam}</td>
                  {cellen.map((c) => (
                    <td key={c.week} className={c.verleden ? 'bez-terug' : c.week === deze ? 'bez-nu' : undefined} style={{ textAlign: 'center', background: KLEUR[c.status] }} title={`Gepland ${fmtUren(c.gepland)}u + Outlook ${fmtUren(c.bezet)}u${c.sprint ? ` + sprintwerk ~${fmtUren(c.sprint)}u` : ''} van ${fmtUren(c.beschikbaar)}u beschikbaar`}>
                      {c.status === 'voorbij' ? 'voorbij' : c.pct == null ? 'afwezig' : `${Math.round(c.pct * 100)}%`}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
